var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',{attrs:{"size":"medium","type":_vm.status === '00'
      ? 'warning'
      : _vm.status === '01'
      ? 'success'
      : _vm.status === '02' || _vm.status === '03'
      ? 'danger'
      : _vm.status === '07'
      ? 'info'
      : 'primary'}},[_vm._v("\n  "+_vm._s(_vm.$formatter.formatOrderStatus(null, null, _vm.status, null))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }